import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCursorAi: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCursorAi"><Path d="M13.4 2H12.6L11.6 4.6L9 5.6V6.4L11.6 7.4L12.6 10H13.4L14.4 7.4L17 6.4V5.6L14.4 4.6L13.4 2Z" fill="currentColor"/><Path d="M7.09082 4.19043L7 4.22656V7.77344L10.0518 8.94727L11.2266 12H14.7734L15.9473 8.94727L17.3398 8.41113L23.582 10.9814L14.7012 14.7861L9.78418 23.3936L2.3125 2.22363L7.09082 4.19043Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCursorAi;
